/* @flow */
import Link from 'components/Link';
import * as React from 'react';
import Textarea from 'components/Textarea';

import './styles/ChatForm.scss';

type Props = {
  chatName: string,
  updateTitle: (title: string) => void,
};

type State = {
  isEditing: boolean,
  chatName: string,
};

class ChatForm extends React.Component<Props, State> {
  state: State = {
    isEditing: false,
    chatName: this.props.chatName,
  };

  componentWillReceiveProps(nextProps: Props) {
    this.setState({
      isEditing: false,
      chatName: nextProps.chatName,
    });
  }

  componentDidUpdate() {
    if (this.state.isEditing && this.refs.textarea) {
      this.refs.textarea.select();
    }
  }

  onChange = (event: SyntheticEvent<>) => {
    this.setState({
      // $FlowFixMe
      chatName: event.target.value,
    });
  };
  onSave = () => {
    this.setState({
      isEditing: false,
    });
    const isEmpty = this.state.chatName.trim() === '';
    const wasChanged = this.state.chatName !== this.props.chatName;

    if (isEmpty) {
      this.setState({
        chatName: this.props.chatName,
      });
    } else if (wasChanged) {
      this.props.updateTitle(this.state.chatName);
    }
  };
  onEdit = () => {
    this.setState({
      isEditing: true,
    });
  };
  renderChatFormHeader = () => {
    return (
      <div className="ChatForm-header">
        <h2 className="ChatForm-header-title">Group Name</h2>
        <Link
          className="ChatForm-header-toggle"
          weight="semibold"
          onClick={this.state.isEditing ? this.onSave : this.onEdit}
          eventElementName="ChatForm-header-toggle">
          {this.state.isEditing ? <span>Save</span> : <span>Rename</span>}
        </Link>
      </div>
    );
  };
  render() {
    const chatNameDisplay = this.state.isEditing ? (
      <Textarea
        className="ChatForm-name"
        autoselect
        rows={2}
        value={this.state.chatName}
        onChange={this.onChange}
      />
    ) : (
      <h2 className="ChatForm-name">{this.state.chatName}</h2>
    );
    return (
      <div className="ChatForm">
        {this.renderChatFormHeader()}
        {chatNameDisplay}
      </div>
    );
  }
}

export default ChatForm;
